module.exports = __webpack_public_path__ + "img/93957.acb1c9bf.svg";